export const CHECKOUT_STARTED = 'checkout_started';
export const CHECKOUT_STEP_COMPLETED = 'checkout_step_completed';
export const CHECKOUT_STEP_VIEWED = 'checkout_step_viewed';
export const ORDER_COMPLETED = 'order_completed';
export const PAYMENT_FAILED = 'payment_failed';
export const PAYMENT_INFO_SUBMITTED = 'payment_info_submitted';

// Original events from utitlies/analytics
export const PODERSALUD_ADDRESS_CONFIRMATION_LANDS = 'podersalud_address_confirmation_lands';
export const PODERSALUD_ADDRESS_CONFIRMATION_SUBMITTED = 'podersalud_address_confirmation_submitted';
export const PODERSALUD_ADDRESS_INPUTTED = 'podersalud_address_inputted';
export const PODERSALUD_ANNUAL_PLAN_SELECTED = 'podersalud_annual_plan_selected';
export const PODERSALUD_BENEFITS_SELECTED = 'podersalud_benefits_selected';
export const PODERSALUD_LANDING = 'podersalud_landing';
export const PODERSALUD_MONTHLY_PLAN_SELECTED = 'podersalud_monthly_plan_selected';
export const PODERSALUD_PAYMENT_LANDS = 'podersalud_payment_lands';
export const PODERSALUD_PAYMENT_SUBMITTED = 'podersalud_payment_submitted';
export const PODERSALUD_PAYMENT_SUCCESSFUL = 'podersalud_payment_successful';
export const PODERSALUD_PERSONAL_INFO_INPUTTED = 'podersalud_personal_info_inputted';
export const PODERSALUD_PERSONAL_INFO_LANDS = 'podersalud_personal_information_lands';
export const PODERSALUD_PERSONAL_INFO_SUBMITTED = 'podersalud_personal_information_submitted';
export const PODERSALUD_SIGN_UP_CLICKED = 'podersalud_sign_up_clicked';

export const BENEFIT_ENGAGEMENT = 'benefit_engagement';
export const PRODUCT_INTEREST = 'product_interest';
export const SSO_SUCCESSFUL = 'sso_successful';

export const PANELIST_PRODUCT_ID = 4;
export const PARTICIPATION_PRODUCT_ID = 9;
export const PODERCARD_PRODUCT_ID = 6;
export const PODERSALUD_PRODUCT_ID = 10;

// Events for Rewards:
export const LINK_CLICK = 'link_click';
export const MODAL_EXIT = 'modal_exit';
export const MODAL_OPEN = 'modal_open';
